import React from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";
import * as routes from "../constants/routes";

const PrivateRoute = ({ user, component: Component }) =>
  user ? <Component user={user} /> : <Navigate to={routes.LANDING} replace />;

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(PrivateRoute);
